// Deterministic pay-first bucketing — the EXACT mirror of the server's
// services/experiment.js so a visitor's variant is identical on both sides and
// stable across visits. If you change one, change the other.

// FNV-1a 32-bit hash of a string → a stable float in [0, 1).
export function hashToUnitInterval(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0) / 4294967296;
}

// True when this visitor falls in the pay-first variant, given the experiment's
// percent (0–100). No visitorId or a non-positive percent → false (normal
// free-preview flow); percent >= 100 → everyone.
export function isPayFirstVisitor(visitorId, percent) {
  const p = Number(percent);
  if (!visitorId || !(p > 0)) return false;
  if (p >= 100) return true;
  return hashToUnitInterval(`payfirst:${visitorId}`) * 100 < p;
}
